import { colors } from "../theme/tokens";

export default function Field({ label, children, style }) {
  return (
    <div style={style}>
      <label style={{
        display: "block", fontSize: 11, letterSpacing: 2,
        textTransform: "uppercase", color: colors.textMuted, marginBottom: 8,
      }}>
        {label}
      </label>
      {children}
    </div>
  );
}
